import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { AddEditFamilyComponent } from './addEditFamily.component';

import { FamilyModel } from '../../../model/index';
import { FamilyService } from '../../../services/index';

@Component({
    selector: 'family-tab',
    templateUrl: './family.component.html',
})
export class FamilyMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public list: any[] = [];
    familyList: any[] = [];

    isLoadMask: Promise<any>;
    familydata: FamilyModel[];
    isLoading: boolean = false;
    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'family_name',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;

    constructor(private familyService: FamilyService, private modalService: BsModalService) { }


    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Name', prop: 'family_name', width: 280, minWidth: 280, maxWidth: 280 },
            { name: 'Brand', prop: 'brand_name', width: 200, minWidth: 200, maxWidth: 200 },
            { name: 'Action', prop: 'sno', width: 105, minWidth: 105, maxWidth: 105, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

        this.pageCallback({ offset: 0 });
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getFamilyList();
        }
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }
    getFamilyList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`
        };
        let that = this;
        this.isLoadMask = this.familyService
            .getFamilyList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.familyList = res.data;
            });
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getFamilyList();
    }

    bsModalRef: BsModalRef;
    public onAddEditFamily(mode: string, row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(AddEditFamilyComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        row['mode'] = mode;
        this.bsModalRef.content.title = mode + ' Family Details';

        this.bsModalRef.content.familydata = Object.assign({}, row);
        this.bsModalRef.content.familyLoadEvent.subscribe(($e) => {
            that.getFamilyList();
            //this.store.dispatch(new commonActions.LoadAllBranch());
        });
    }

    onDeleteFamily(row: any): void {
        let that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover Family: ' + row.family_name + ' Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.familyService
                .deleteFamily(row.family_id)
                .then(function(res: any) {
                    if (res.success) {
                        that.getFamilyList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }

                });
        }, function(dismiss) {

        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/family/family.component.ts